import React from "react";

import { Props } from "./types";

function TaskIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 17 12.217">
      <path
        d="M115.723,147.386a2.139,2.139,0,0,0-2.994-.107l-6.844,6.523L103,150.808A2.139,2.139,0,0,0,100,150.7a2.245,2.245,0,0,0,0,3.1l4.385,4.492a1.924,1.924,0,0,0,1.5.642,2.138,2.138,0,0,0,1.5-.642l8.342-7.913a2.032,2.032,0,0,0,.123-2.871C115.807,147.467,115.766,147.425,115.723,147.386Z"
        transform="translate(-99.381 -146.719)"
      />
    </svg>
  );
}

export { TaskIcon };
